import API from "./api";

const asArray = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  return [];
};

export const getAdminCheckouts = async () => {
  const res = await API.get("/admin/checkouts");
  return asArray(res.data);
};

export const getAdminCheckout = async (id) => {
  const res = await API.get(`/admin/checkouts/${id}`);
  return res.data;
};

export const getAdminReservationCheckout = async (reservationId) => {
  const res = await API.get(`/admin/checkouts/reservation/${reservationId}`);
  return res.data;
};

export const confirmAdminReservationCheckout = async (reservationId, data) => {
  const res = await API.post(`/admin/checkouts/reservation/${reservationId}/confirm`, data);
  return res.data;
};

export const deleteAdminCheckoutPhoto = async (photoId) => {
  const res = await API.delete(`/admin/checkouts/photos/${photoId}`);
  return res.data;
};

export const getTrailerQr = async (trailerId) => {
  const res = await API.get(`/admin/trailers/${trailerId}/qr`);
  return res.data;
};

export const regenerateTrailerQr = async (trailerId) => {
  const res = await API.post(`/admin/trailers/${trailerId}/regenerate-qr`);
  return res.data;
};
